<div
  class="products-list"
  [ngClass]="[
    onlyFavoritesIncluded() && includedIds()?.length === 0 ? 'hide' : '',
  ]"
>
  @for (product of products(); track product.ID) {
    <claas-product-card
      [id]="product.ID ?? ''"
      [title]="product.Name ?? ''"
      [text]="product.EmissionStage ?? ''"
      [imgUrl]="product.AssetLink ?? ''"
    ></claas-product-card>
  }
</div>
